import { fetchConToken, fetchSinToken } from "../utils/fetch.ts";


export const modificarContrasena = async (password1:string, password2:string) => {
  try {
    const resp = await fetchConToken("misdatos/actualizar-clave", { password1, password2 }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};

export const modificarMisDatos = async (email:string, nombre:string, apellido:string, telefono:string, comuna_id:number) => {
  try {
    const resp = await fetchConToken("misdatos/actualizar", { email, nombre, apellido, telefono, comuna_id }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return {};
  }
};
